import React from "react";
import { Stepper, Step, StepLabel, Box } from "@mui/material";

interface BulkStepLayoutProps {
  step: number;
  children: React.ReactNode;
  onNext?: () => void;
  onBack?: () => void;
  steps: string[];
}

const BulkStepLayout: React.FC<BulkStepLayoutProps> = ({ step, children, steps }) => {
  return (
    <Box sx={{ width: '100%' }} className="bulk-step">
      <Stepper activeStep={step} alternativeLabel>
        {steps.map((label, idx) => (
          <Step key={label} completed={step > idx}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <Box sx={{ my: 2 }}>{children}</Box>
      {/* Navigation buttons removed; handled by step content */}
    </Box>
  );
};

export default BulkStepLayout;
